import { Button as GSButton, styled } from "@gluestack-ui/themed";

export const StyledButton = styled(GSButton, {
  borderRadius: 8,
});
